import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import SEO from "@/components/SEO";
import { api } from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import { toast } from "sonner";

const inputCls = "w-full rounded-xl bg-black/40 border border-[color:var(--border-subtle)] px-4 py-3 text-sm text-white placeholder:text-white/35 focus:outline-none focus:ring-2 focus:ring-[color:var(--ring)]";

export default function AccountReset() {
  const nav = useNavigate();
  const site = useSite();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [busy, setBusy] = useState(false);
  const [pw, setPw] = useState("");
  const [cpw, setCpw] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== cpw) { toast.error("Passwords do not match."); return; }
    setBusy(true);
    try {
      await api.post("/client/reset-password", { token, password: pw, confirm_password: cpw });
      toast.success("Password updated — you're signed in.");
      window.dispatchEvent(new Event("ascendia-auth-change"));
      nav("/account");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not reset password");
    } finally { setBusy(false); }
  };

  return (
    <>
      <SEO title="Reset password" noindex />
      <div className="min-h-screen bg-[#0B0B0C] text-white flex items-center justify-center px-4 py-16">
        <div className="w-full max-w-md">
          <div className="text-center mb-6">
            <Link to="/" className="inline-flex items-center gap-2.5 mb-5"><img src={site.logo} alt="Ascendia Detail" className="h-10 w-10 object-contain" /><span className="font-display text-xl font-semibold">Ascendia <span className="text-gold">Detail</span></span></Link>
            <h1 className="font-display text-2xl font-semibold text-white">Set a new password</h1>
          </div>
          {!token ? (
            <div className="ascendia-card p-6 text-center text-sm text-muted-c">This reset link is missing its token. Please request a new link from the login page.</div>
          ) : (
            <form onSubmit={submit} className="ascendia-card card-accent-top p-6 space-y-3">
              <input className={inputCls} type="password" placeholder="New password (min 8, letters + numbers)" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password" />
              <input className={inputCls} type="password" placeholder="Confirm new password" value={cpw} onChange={(e) => setCpw(e.target.value)} data-testid="reset-confirm" />
              <button type="submit" disabled={busy} data-testid="reset-submit" className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-gold px-6 py-3 text-sm font-semibold text-black hover:bg-gold-soft disabled:opacity-50">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Update password"}</button>
            </form>
          )}
          <Link to="/account/login" className="mt-4 block text-center text-sm text-muted-c hover:text-white">← Back to log in</Link>
        </div>
      </div>
    </>
  );
}
